import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import LegalPage from "@/pages/LegalPage";
import { PRIVACY_DOC, TERMS_DOC } from "@/data/legal";
import CrmLogin from "@/pages/crm/CrmLogin";
import CrmForgot from "@/pages/crm/CrmForgot";
import CrmReset from "@/pages/crm/CrmReset";
import CrmDashboard from "@/pages/crm/CrmDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/manifesto" element={<LandingPage />} />
          <Route path="/termos-de-uso" element={<LegalPage doc={TERMS_DOC} />} />
          <Route path="/politica-de-privacidade" element={<LegalPage doc={PRIVACY_DOC} />} />
          <Route path="/crm" element={<CrmDashboard />} />
          <Route path="/crm/login" element={<CrmLogin />} />
          <Route path="/crm/recuperar" element={<CrmForgot />} />
          <Route path="/crm/redefinir" element={<CrmReset />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
